// IndustryPieView
var $ = require('jquery');
var Marionette = require('backbone.marionette');
var _ = require('underscore');
var d3 = require('d3');
var template = require('./template.hbs');
var ChartView = require('../../../common/chart-view.js');

module.exports = ChartView.extend({
	template: template,
  className: 'pie',
	specs: {},

	constructor: function(options){
		ChartView.apply(this, arguments);
		this.create_tooltip();
		this.registerEvents();

		return this;
	},

	// Workaround: for chart-wrapper not working on ChartView initialize. Proven working on MapsView.
	onAttach: function(){
		this.$el.wrap($('<div class="chart-wrapper">'));
		this.draw();
	},

	onBeforeRender: function(){
		// Need to filter to only active on unzoomed and zoomed
		if( UCS.App.MapState.get('zoomed') === true ){
			this.collection = UCS.App.MapState.get('matched_models_active_coll');
		}else{
			this.collection = UCS.App.MapState.get('collection_copy').onlyActive();
		}
	},

	registerEvents: function(){
		this.listenTo( UCS.App.MapState,'change:selection', this.update, this);
		this.listenTo( UCS.App.MapState,'change:zoomed', this.update, this);
	},

	update: function(){
		this.render();
	},

	draw: function(){
		var chart = this;
		// Workaround: re-define these two after re-adding the chart-wrapper since it didn't quite get it on ChartView init
		this.$chart_container = this.$el.parent();
		this.chart_container = this.$chart_container.get(0);
		this.$chart_container.attr('id', 'industry-pie-container');

		chart.data = this.process_data( this.collection.toJSON() );
		this.$el.empty();
		this.get_dimensions();
		this.get_specifics();
		this.create_svg();
		this.draw_pie();
		this.bind_mouse_events();
		return this;
	},

	get_specifics: function(){
		var chart = this;
		var specs = this.specs;

		specs.radius = Math.min(chart.dimensions.wrapperWidth, chart.dimensions.wrapperHeight) / 2;

		// specs.color = d3.scale.category20();
		specs.color = d3.scale.ordinal()
			.domain(["Medical", "Information Technology", "Research Tools", "Energy", "Advanced Materials", "Agriculture", "Environment", "Transportation"])
			.range(["#72cdf4","#1295d8", "#00778B", "#FF6E1B", "#FF8F28", "#ffd200", "#ffe552", "#FEB2E0",]);
		specs.arc = d3.svg.arc()
	    .outerRadius(specs.radius)
	    .innerRadius(specs.radius - specs.radius/2);

		specs.labelArc = d3.svg.arc()
	    .outerRadius(specs.radius - 40)
	    .innerRadius(specs.radius - 40);

		specs.pie = d3.layout.pie()
	    .sort(null)
	    .value(function(d) {
				return d.startups; });

	},

	create_svg: function() {
		var chart = this;
		var specs = this.specs;

		chart.svg = d3.select(chart.el).append("svg")
	    .attr("width", chart.dimensions.wrapperWidth)
	    .attr("height", chart.dimensions.wrapperHeight)
		  .append("g")
		    .attr("transform", "translate(" + chart.dimensions.wrapperWidth / 2 + "," + chart.dimensions.wrapperHeight / 2 + ")");
	},

	draw_pie: function(){
		var chart = this;
		var specs = this.specs;
		var data = chart.data;
		var coll = chart.collection;

		var pie = chart.specs.pie,
			color = chart.specs.color,
			arc = chart.specs.arc,
			labelArc = chart.specs.labelArc;

		// Put Industry list into right side box
		$('.industry-pie .box2 ul').empty();

		// initial data, print out largest industry's details
		$('.industry-pie .box2 h3').text(data[0].industry);
		$('.industry-pie .box2 .startups').text( data[0].startups);
		$('.industry-pie .box2 .revenue').text( coll.formatBigCurrency(data[0].revenue) );
		$('.industry-pie .box2 .jobs').text( coll.formatCommas(data[0].jobs) );

		// Data Join!
		var arcs = chart.svg.selectAll(".arc")
      .data(pie(data));

		// Enter & Update
		arcs.enter().append("g")
	    .attr("class", "arc");

	  arcs.append("path")
      .attr("d", arc)
      .style("fill", function(d) {
				return color(d.data.industry);
			});

		// Update
		// arcs.transition().duration(1000)
		// 	.attr("d", arc);

		// Exit...
		// arcs.exit()
	  //   .attr("class", "exit")
	  //   .transition().duration(750)
	  //     .style("opacity", 0)
	  //     .remove();

		// arcs.append("text")
		// 	.attr("transform", function(d) { return "translate(" + labelArc.centroid(d) + ")"; })
		// 	.attr("dy", ".35em")
		// 	.text(function(d) {
		// 		industryArray.push(d.data[0]);
		// 		return d.data[0];
		// 	});

		return this;
	},

	create_center_label: function(){

	},

	create_tooltip: function(){
		var chart = this;

		var tooltip_fields = {
			1: ['h3', 'title'],
			2: ['p', 'startups']
		};

		if( !$('#tooltip2').length ){

	    chart.tooltip = d3.select("body")
	      .append("div")
	        .attr("id", "tooltip2")
					.attr("class","tooltip")
	        .style("position", "absolute")
	        .style("z-index", "10")
	        .style("visibility", "hidden");
		}else {
			$('#tooltip2').empty();
			chart.tooltip = d3.select("#tooltip2");
		}

		_.each(tooltip_fields, function(element, index, list){

			var tooltip = d3.select("#tooltip2");

			tooltip.append(element[0])
				.attr("class", element[1]);

			tooltip.select("."+element[1])
				.insert("span")
				.attr("class", "label");

			tooltip.select("."+element[1])
				.insert("span")
				.attr("class", "value");
		});

	    // //create a paragraph in the tooltip div for text
	    // d3.select("#tooltip2")
	    //   .append("h3")
	    //   .attr("class", "bold")
	    //   .text("Year");
			//
	    // //create a paragraph in the tooltip div for text
	    // d3.select("#tooltip2")
	    //   .append("p")
	    //   .attr("class", "value")
	    //   .text("Element value");

	},

	bind_mouse_events: function(){
		var chart = this;
		var coll = this.collection;
		var data = chart.data;

		var lacksTouchEvents = $('html').hasClass('no-touchevents');
		if(lacksTouchEvents){
			chart.svg.selectAll("path")
	      .on("mouseover", function(d) {

	        //update tool tip text
	        d3.select("#tooltip2")
	          .select(".title")
	          .text(d.data.industry);

					d3.select("#tooltip2 .startups .label")
						.text('Startups ');

	        d3.select("#tooltip2 .startups .value")
	          .text(d.data.startups);

	        return chart.tooltip.style("visibility", "visible");
	      })
	      .on("mousemove", function() {
	        var svg_width = d3.select(chart.el)[0][0].clientWidth;
	        var tip_width = $(chart.tooltip[0][0]).width();

	        //set position of the tooltip based on mouse position (simplified from map version)
	        chart.tooltip
						.style("top", (d3.event.pageY-10)+"px")
						.style("left",(d3.event.pageX+10)+"px");
	      })
	      .on("mouseout", function(){
	        return chart.tooltip.style("visibility", "hidden");
	      });
		}

		chart.svg.selectAll("path")
			.on("click", function(d){
				$('.industry-pie .box2 h3').text(d.data.industry);
				$('.industry-pie .box2 .startups').text( d.data.startups);
				$('.industry-pie .box2 .revenue').text( coll.formatBigCurrency(d.data.revenue) );
				$('.industry-pie .box2 .jobs').text( coll.formatCommas(d.data.jobs) );
			});
	},

	process_data: function(data){
		var groups = _.groupBy(data,'tech_broad');

		var output = _.map(groups, function(g, key) {
		  return {
				industry: key,
				startups: _.reduce(g, function(memo) { return memo + 1; }, 0),
	      revenue: _.reduce(g, function(memo,x) { return memo + x.total_revenue; }, 0),
				jobs: _.reduce(g, function(memo,x) { return memo + x.employees; }, 0)
			};
		});

		output = _.sortBy(output, 'startups');
		output = output.reverse();

		return output;

	}
});
